import { environnement } from "configs/environnement";
import api from "./api";
import {
  IAttendanceResponse,
  ISaveAttendance,
  IUpdateAttendance,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/attendances`;

export const AttendanceService = {
  /**
   * Récupérer une présence par son ID
   */
  getById: async (id: number): Promise<IAttendanceResponse> => {
    const response = await api.get<IAttendanceResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Créer un enregistrement de présence
   */
  create: async (attendance: ISaveAttendance): Promise<IAttendanceResponse> => {
    const response = await api.post<IAttendanceResponse>(
      `${BASE_URL}`,
      attendance,
    );
    return response.data;
  },

  /**
   * Modifier un enregistrement de présence existant
   */
  update: async (
    attendance: IUpdateAttendance,
  ): Promise<IAttendanceResponse> => {
    const response = await api.put<IAttendanceResponse>(
      `${BASE_URL}`,
      attendance,
    );
    return response.data;
  },

  /**
   * Supprimer une feuille ou une ligne de présence
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Rechercher des présences via Elasticsearch (avec fallback global)
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IAttendanceResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "lastModifiedDate,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * GET /v1/attendances/event/{eventId}
   * Récupérer toutes les présences rattachées à un événement spécifique
   */
  getByEvent: async (eventId: number, page: number, size: number) => {
    const response = await api.get<IAttendanceResponse[]>(
      `${BASE_URL}/event/${eventId}`,
      {
        params: {
          page: page,
          size: size,
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * GET /v1/attendances/member/{memberId}
   * Historique complet des présences d'un membre spécifique
   */
  getByMember: async (memberId: number, page: number, size: number) => {
    const response = await api.get<IAttendanceResponse[]>(
      `${BASE_URL}/member/${memberId}`,
      {
        params: {
          page: page,
          size: size,
          sort: "createdDate,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
